module.exports = __webpack_public_path__ + "f4517d3f1b839e47541e0f92c854d9e4.svg";